'use client';

import { useEffect } from 'react';
import { useUTM } from '@/lib/hooks/use-utm';
import { useSession } from 'next-auth/react';
import posthog from 'posthog-js';

/**
 * AttributionTracker
 * Enriches PostHog sessions with UTM data and user identity.
 */
export function AttributionTracker() {
  const { data: session } = useSession();
  const utm = useUTM();

  useEffect(() => {
    if (session?.user?.email) {
      posthog.identify(session.user.email, {
        email: session.user.email,
        name: session.user.name,
      });
    }

    // Attach UTM data to the person profile
    // utm is now guaranteed to be an object by useUTM update
    if (utm && Object.keys(utm).length > 0) {
      posthog.setPersonProperties(utm);
    }
  }, [session, utm]);

  return null;
}
